import { PaginationMeta } from './pagination';
import { User } from './user';
import { Organization } from './organization';
import { OrganizationProfile } from './organization-profile';
import { BaseAvatar } from './base/avatar';
import { Membership } from './membership';
import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';
import moment from 'moment-timezone';
import { Moment } from 'moment';
import environment from '../../../environments/environment';

export class PropertyManagementCompany extends BaseAvatar
{
    id: number;
    email: string;
    phone: string;
    zip: string;
    ein: string;
    stripeCustomerId: string;
    defaultPaymentMethodId: string;
    membersCount: number;
    organizationsCount: number;
    unitsCount: number;
    createdInProduction: boolean;
    users: User[];
    organizations: Organization[];
    orgCityStates: OrganizationProfile[];
    orgAdmins: Membership[];
    createdAt: Moment;
    updatedAt: Moment;
    deletedAt: Moment;

    constructor(obj: any) {
        super(obj);

        this.id = obj.id || null;
        this.email = obj.email || null;
        this.phone = obj.phone || null;
        this.zip = obj.zip || null;
        this.ein = obj.ein || null;
        this.stripeCustomerId = obj.stripeCustomerId || null;
        this.defaultPaymentMethodId = obj.defaultPaymentMethodId || null;
        this.membersCount = obj.membersCount || null;
        this.organizationsCount = obj.organizationsCount || null;
        this.unitsCount = obj.unitsCount || null;
        if(environment.production) {
            this.createdInProduction = true;
        } else {
            this.createdInProduction = obj.createdInProduction || false;
        }

        if (obj.users) {
            this.users = obj.users.map((u: any) => new User(u));
        }

        if (obj.organizations) {
            this.organizations = obj.organizations.map((o: any) => new Organization(o));
        }

        if (obj.orgCityStates) {
            this.orgCityStates = obj.orgCityStates.map((o: any) => new OrganizationProfile(o));
        }

        if (obj.orgAdmins) {
            this.orgAdmins = obj.orgAdmins.map((o: any) => new Membership(o));
        }

        const timezone = LegFiJwtService.getTimezone();
        if (obj.createdAt) {
            this.createdAt = moment.utc(obj.createdAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
        if (obj.updatedAt) {
            this.updatedAt = moment.utc(obj.updatedAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
        if (obj.deletedAt) {
            this.deletedAt = moment.utc(obj.deletedAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
    }
}

export class PropertyManagementCompanyResponse
{
    data: PropertyManagementCompany[];
    meta: PaginationMeta;

    constructor(request: any) {
        this.data = (request.data && request.data.length) ? request.data.map((c: any) => {
            return new PropertyManagementCompany(c);
        }) : [];
        this.meta = new PaginationMeta(request);
    }
}
